import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export const vimeoEmbedUrl = (video) =>
  `https://player.vimeo.com/video/${video.id}?h=${video.hash}&autoplay=1&title=0&byline=0&portrait=0&vimeo_logo=0&dnt=1&pip=0`;

export const VideoModal = ({ video, onClose }) => {
  const { lang, t } = useLanguage();

  return (
    <Dialog.Root open={Boolean(video)} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay
          className="fixed inset-0 z-[90] bg-ink-950/95 backdrop-blur-md data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0"
          data-testid="video-modal-overlay"
        />
        <Dialog.Content
          className="fixed left-1/2 top-1/2 z-[100] w-[calc(100vw-2rem)] max-w-6xl -translate-x-1/2 -translate-y-1/2 outline-none data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95"
          data-testid="video-modal"
          onContextMenu={(e) => e.preventDefault()}
        >
          {video && (
            <>
              <div className="mb-3 flex items-center justify-between gap-4">
                <Dialog.Title className="font-display text-lg font-semibold uppercase tracking-wide text-white sm:text-xl">
                  {video.title[lang]}
                </Dialog.Title>
                <Dialog.Description className="sr-only">{t.videos.play}</Dialog.Description>
                <Dialog.Close
                  className="inline-flex h-10 w-10 items-center justify-center border border-ink-700/60 bg-ink-900 text-zinc-300 transition-colors duration-200 hover:border-kit hover:text-kit"
                  aria-label={t.videos.close}
                  data-testid="video-modal-close"
                >
                  <X size={18} />
                </Dialog.Close>
              </div>
              <div className="relative aspect-video w-full overflow-hidden border border-ink-700/60 bg-black">
                <iframe
                  src={vimeoEmbedUrl(video)}
                  className="absolute inset-0 h-full w-full"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                  title={video.title[lang]}
                  data-testid="video-modal-iframe"
                />
              </div>
              <p className="mt-3 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                {t.videos.note}
              </p>
            </>
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
